import React from 'react'
import { Box, Paper, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Link as MuiLink } from '@mui/material'
import { usePage, Link } from '@inertiajs/react'
import AppShell from '../../../../components/layout/AppShell'
import PageHeader from '../../../../components/ui/PageHeader'
import StatusBadge from '../../../../components/ui/StatusBadge'
import FormattedCurrency from '../../../../components/ui/FormattedCurrency'

Show.layout = (page) => <AppShell>{page}</AppShell>

export default function Show({ property, journal_entry, lines = [] }) {
  const { props } = usePage()
  const tenant = props.tenant || {}
  const basePath = `/m/${tenant.slug}/properties/${property.id}`

  const totalDebit = journal_entry.total_debit
  const totalCredit = journal_entry.total_credit

  return (
    <Box>
      <PageHeader
        title={`Buchung #${journal_entry.entry_number}`}
        breadcrumbs={[
          { label: property.name, href: basePath },
          { label: 'Journal', href: `${basePath}/journal` },
          { label: `#${journal_entry.entry_number}` },
        ]}
      />

      <Paper elevation={0} sx={{ p: 2, mb: 2, border: '1px solid', borderColor: 'divider' }}>
        <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', alignItems: 'center' }}>
          <StatusBadge type="journal_entry_status" value={journal_entry.status} />
          <Typography variant="body2" color="text.secondary">Buchungsdatum: {journal_entry.entry_date}</Typography>
          {journal_entry.posting_date && (
            <Typography variant="body2" color="text.secondary">Valutadatum: {journal_entry.posting_date}</Typography>
          )}
          <Typography variant="body2" color="text.secondary">Art: {journal_entry.entry_type}</Typography>
        </Box>
        {journal_entry.description && (
          <Typography variant="body2" sx={{ mt: 1 }}>{journal_entry.description}</Typography>
        )}
        {journal_entry.correction_reason && (
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
            Korrekturgrund: {journal_entry.correction_reason}
          </Typography>
        )}
      </Paper>

      <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 600 }}>Buchungszeilen</Typography>
      <TableContainer component={Paper} elevation={0} sx={{ border: '1px solid', borderColor: 'divider' }}>
        <Table size="small">
          <TableHead>
            <TableRow sx={{ backgroundColor: 'background.subtle' }}>
              <TableCell sx={{ fontWeight: 600 }}>Konto</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Bezeichnung</TableCell>
              <TableCell sx={{ fontWeight: 600 }} align="right">Soll</TableCell>
              <TableCell sx={{ fontWeight: 600 }} align="right">Haben</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {lines.map((line) => {
              const accountUrl = line.account_id ? `${basePath}/ledger_accounts/${line.account_id}` : null
              return (
              <TableRow key={line.id}>
                <TableCell>
                  {accountUrl ? (
                    <MuiLink component={Link} href={accountUrl} underline="hover" color="inherit">{line.account_number}</MuiLink>
                  ) : line.account_number}
                </TableCell>
                <TableCell>
                  {accountUrl ? (
                    <MuiLink component={Link} href={accountUrl} underline="hover" color="inherit">{line.account_name}</MuiLink>
                  ) : line.account_name}
                </TableCell>
                <TableCell align="right">{line.debit_amount && line.debit_amount !== '0.0' ? <FormattedCurrency value={line.debit_amount} /> : ''}</TableCell>
                <TableCell align="right">{line.credit_amount && line.credit_amount !== '0.0' ? <FormattedCurrency value={line.credit_amount} /> : ''}</TableCell>
              </TableRow>
              )
            })}
            <TableRow sx={{ backgroundColor: 'background.subtle' }}>
              <TableCell colSpan={2} sx={{ fontWeight: 600 }}>Summe</TableCell>
              <TableCell align="right" sx={{ fontWeight: 600 }}><FormattedCurrency value={totalDebit} /></TableCell>
              <TableCell align="right" sx={{ fontWeight: 600 }}><FormattedCurrency value={totalCredit} /></TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  )
}
